<h2 mat-dialog-title class="title-small">{{ data.title }}</h2>

<mat-dialog-content class="mat-typography email-template-dialog" [formGroup]="form">
    <div class="email-template-summary" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="12px">
        <div fxLayout="column" fxLayoutGap="4px">
            <span class="body-1-regular-2">{{ data.document.companyName }}</span>
            <span class="body-2-regular-2">{{ documentStatus }}</span>
        </div>
        <span class="body-2-regular-2" *ngIf="data.document.documentId">{{ data.document.documentId }}</span>
    </div>

    <div fxLayout="row wrap" fxLayoutGap="16px">
        <mat-form-field fxFlex="1 1 260px" class="custom-text-field" appearance="outline" floatLabel="always">
            <mat-label>Template Name</mat-label>
            <input matInput formControlName="name">
        </mat-form-field>

        <mat-form-field fxFlex="2 1 420px" class="custom-text-field" appearance="outline" floatLabel="always">
            <mat-label>Email Subject</mat-label>
            <input matInput formControlName="subject">
        </mat-form-field>
    </div>

    <mat-form-field class="custom-text-field email-preview-field" appearance="outline" floatLabel="always">
        <mat-label>Preview Text</mat-label>
        <input matInput formControlName="previewText">
    </mat-form-field>

    <div class="email-designer-frame">
        <app-email-template-designer
            #emailDesigner
            [selectedTemplate]="template"
            [offeringUuid]="data.document.companyId"
            [hideActionButtons]="true"
            (selectedTemplateChange)="handleSelectedTemplateChange($event)"
            (saveTemplate)="handleSaveTemplateResult($event)">
        </app-email-template-designer>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="email-template-dialog-actions">
    <button mat-stroked-button type="button" [disabled]="saving" (click)="cancel()">Cancel</button>
    <button class="button-primary" mat-flat-button type="button" [disabled]="saving" (click)="save()">
        <mat-icon>{{ saving ? 'hourglass_empty' : 'save' }}</mat-icon>
        <div class="button-text">{{ saving ? 'Saving' : 'Save Email' }}</div>
    </button>
</mat-dialog-actions>
